<template>
  <UserLayout>
    <section class="lg:ml-20 mt-16 mb-6">
      <div class="flex h-80 p-2 w-full flex-shrink-0 bg-gray-100">
        <div class="flex flex-col w-1/2 pl-16">
          <div class="flex-col uppercase justify-between pt-8 tracking-widest">
            <h1 class="text-5xl">Find</h1>
            <h1 class="text-5xl">On Demand Classes</h1>
          </div>
          <div class="font-bold mt-4 mb-4 tracking-widest">
            Let’s start the climb to the next step <br />
            Find a recorded class now!
          </div>
        </div>

        <div class="w-1/2 p-2">
          <div class="h-52 overflow-hidden my-10 rounded-xl mr-10">
            <img :src="require('@/assets/img/findVodClass.jpg')" alt="..." />
          </div>
        </div>
      </div>
    </section>
    <section class="flex flex-col my-20 md:px-12 xl:px-12 lg:px-16 mt-12 mb-6">
      <div class="px-3 ml-24">
        <div class="flex-col justify-between">
          <div class="flex items-center space-x-1">
            <button
              type="button"
              class="inline-flex items-center h-8 px-1 text-sm transition-colors duration-150 ring-1 text-white rounded-md focus:outline-none bg-green-light hover:text-green-light hover:bg-white ring-green-light"
              @click="handleClickMenu"
            >
              <p class="text-sm px-1">Filters</p>
              <FilterIcon />
            </button>
          </div>
          <div class="my-4 text-gray-light">
            Showing 1-20 out of 300 results for “Health”
          </div>
        </div>
        <div class="grid md:grid-cols-4 grid-cols-2 gap-4">
          <SessionCard :data="completedSessions" />
        </div>
      </div>
    </section>
  </UserLayout>
</template>

<script>
import UserLayout from "../../../components/layouts/UserLayout.vue";
import { Star, FilterIcon } from "@/components/icons";
import { mapGetters, mapActions } from "vuex";
import SessionCard from "@/components/SessionCard";

export default {
  components: { UserLayout, Star, FilterIcon, SessionCard },
  data() {
    return {
      completedSessions: [],
    };
  },
};
</script>

<style></style>
